import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import api from 'axios';
import memoize from 'lodash/memoize';
const API_URI = 'https://cerebro.k8s.hipages.com.au/suggest/location';

export function renderSuggestion(suggestion) {
  return `${suggestion.postcode} - ${suggestion.suburb}`;
}

export function getSuggestionValue(suggestion) {
  return `${suggestion.postcode} - ${suggestion.suburb}`;
}

const fetchSuggestions = memoize(query => api.get(API_URI, { params: { keyword: query } }));

export function makeTheme(prefix) {
  return {
    container: `${prefix}__container`,
    containerOpen: `${prefix}__container--open`,
    input: `${prefix}__input`,
    suggestionsContainer: `${prefix}__suggestions-container`,
    suggestionsList: `${prefix}__suggestions-list`,
    suggestion: `${prefix}__suggestion`,
    suggestionHighlighted: `${prefix}__suggestion--focused`,
    sectionContainer: `${prefix}__section-container`,
    sectionTitle: `${prefix}__section-title`
  };
}

export default class PostcodeSearch extends Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    inputClassName: PropTypes.string,
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    inputProps: PropTypes.object,
    fetchSuggestions: PropTypes.func.isRequired,
    highlightFirstSuggestion: PropTypes.bool,
    onSuggestionSelected: PropTypes.func,
    renderInputComponent: PropTypes.func
  };

  static defaultProps = {
    value: '',
    onChange: f => f,
    onSuggestionSelected: f => f,
    fetchSuggestions
  };

  state = {
    suggestions: [],
    theme: {},
    value: ''
  };

  componentWillMount() {
    this.setState({
      theme: makeTheme(this.props.classPrefix),
      value: this.props.value
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  onSuggestionsFetchRequested = ({ value }) => this.loadSuggestions(value);

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onChange = (event, { newValue }) => {
    const { onChange } = this.props;
    onChange(newValue);
    this.setState({ value: newValue });
  };

  loadSuggestions = query =>
    this.props.fetchSuggestions(query).then(response => {
      this.setState({ suggestions: response.data });
    });

  render() {
    const { suggestions, theme, value } = this.state;
    const {
      renderInputComponent,
      className,
      classPrefix,
      onSuggestionSelected,
      fetchSuggestions,
      inputProps,
      highlightFirstSuggestion,
      ...rest
    } = this.props;
    const inputPropsPassIn = {
      ...rest,
      ...inputProps,
      onChange: this.onChange
    };
    return (
      <Autosuggest
        className={`${classPrefix}__container ${className}`}
        suggestions={suggestions}
        inputProps={inputPropsPassIn}
        renderInputComponent={renderInputComponent}
        renderSuggestion={renderSuggestion}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={getSuggestionValue}
        theme={theme}
        ignoreProps={[fetchSuggestions]}
        highlightFirstSuggestion={highlightFirstSuggestion}
      />
    );
  }
}
